import { FC } from 'react';
import { Kalenderhändelse } from '../../types/pages';
import styles from './KalenderHändelseTag.module.css';

import { Tag } from '@kpa/kul';

type KalenderHändelseTagProps = {
  händelse: Kalenderhändelse;
};

const KalenderHändelseTag: FC<KalenderHändelseTagProps> = ({ händelse }) => {
  return (
    händelse.category.length > 0 && (
      <div className={styles.container}>
        {händelse.category.map((kategori, index) => (
          <Tag className={styles.kategori} key={index} text={kategori} variant="neutral" />
        ))}
      </div>
    )
  );
};

export default KalenderHändelseTag;
